// fullFaceBotoxData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[] | any;
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const fullFaceBotoxData: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} = {
    "en": {
        "url": "full-face-botox-dubai",
        "meta": {
            "title": "Full Face Botox Dubai | Elite Body Home Polyclinic",
            "description": "Look young and rejuvenated with our Full Face Botox in Dubai. Smooth fine lines, soften wrinkles, and prevent aging signs with customized treatments by skilled practitioners.",
            "robots": "index, follow",
            "canonical": "",
            "og": {}
        },
        "breadcrumbs": ["Home", "Services", "Full Face Botox Dubai"],
        "hero": {
            "title": "Botox Dubai",
            "subtitle": "Full Face Botox Treatment",
            "description": "Look young and rejuvenated with our Botox Full Face at Elite Body Home Polyclinic Dubai. From smoothing out fine lines, to softening deep wrinkles, to preventing the signs of aging, our skilled practitioner provides customized Botox treatments based on your unique aesthetic goals."
        },
        "howItWorks": {
            "title": "Botox Injection: How It Works",
            "description": "Botox injections are an injectable cosmetic treatment that temporarily paralyzes the muscles that cause fine lines and wrinkles. The injections use small and controlled doses of Botulinum Toxin that are injected into specific facial muscles to temporarily relax and smooth, reducing the appearance of dynamic wrinkles like forehead lines, frown lines, and crow's feet. Well trained professionals will make sure to administer them correctly and safely for a natural looking results."
        },
        "procedureSteps": {
            "heading": "Step-by-Step Botox Rejuvenation Procedure",
            "para": "Full Face Botox process consists of multiple important steps to assure safety, efficiency, and natural result. A licensed and experienced practitioner performs the treatment, which usually takes 20–45 minutes. Here's a high-level description of the process.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "The specialist analyzes your facial features, and your goals, to outline a customized treatment plan.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "Preparation",
                    "desc": "The skin is sanitized and numbing cream might be put on it. Aggregate keys and important injection points are annotated.",
                    "icon": "fa-solid fa-spray-can-sparkles"
                },
                {
                    "title": "Injections",
                    "desc": "A fine needle is used to inject Botox into the desired areas. It takes around 10-15 minutes, tolerable discomfort.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Session Duration",
                    "desc": "Session typically lasts around 15 to 30 minutes, depending on the areas being treated and individual needs.",
                    "icon": "fa-solid fa-stopwatch"
                }
            ]

        },
        "eligibility": {
            "heading": "Who Is Full Face Botox For?",
            "subheading": "Find out if it’s for you",
            "para": "Botox Full Face Treatment is intended for those who are looking for a non-invasive way to improve their appearance, reduce wrinkles and achieve a more youthful look. Here’s how to know whether this treatment is for you.",
            "items": [
                {
                    "title": "Early Signs of Aging",
                    "desc": "If you’re seeing fine lines, crow’s feet, or forehead wrinkles, Botox will smooth them out for a fresher appearance.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "Non-Surgical Treatments",
                    "desc": "Perfect for patients who desire a more dramatic, but still natural, change without the risks of surgery or downtime.",
                    "icon": "fa-solid fa-hand-holding-heart"
                },
                {
                    "title": "Preventive Treatment",
                    "desc": "Botox can vary within age ranges...younger audience doing botox is something you can do as a preventer...",
                    "icon": "fa-solid fa-shield-heart"
                },
                {
                    "title": "Personalized Care",
                    "desc": "Botox Full Face offers targeted treatments for the forehead, eyes, jawline, and more...",
                    "icon": "fa-solid fa-user-gear"
                }
            ]

        },
        "preparationTips": {
            "heading": "How to Get Ready for Your Botox Full Face Procedures?",
            "subheading": "Preparation Tips",
            "para": "In order to obtain the best results from your Botox Full Face Treatment, it is necessary to prepare correctly. Here are some critical tips for ensuring a positive experience and the enduring benefits of smoking cessation:",
            "items": [
                {
                    "title": "Consult with a Professional",
                    "desc": "Book a consultation for them to discuss your goals and make sure that Botox is right for you.",
                    "icon": "fa-solid fa-comments-medical"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "Avoid aspirin, ibuprofen and supplements such as fish oil a week before your appointment...",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "Skip Alcohol",
                    "desc": "Do not drink alcohol for 24 hours prior to your appointment in order to limit swelling.",
                    "icon": "fa-solid fa-wine-glass-crack"
                },
                {
                    "title": "Arrive with Clean Skin",
                    "desc": "On the day of your treatment, arrive with clean skin, no makeup or lotions.",
                    "icon": "fa-solid fa-soap"
                }
            ]

        },
        "benefits": {
            "heading": "Botox Full Face Treatment",
            "subheading": "The full face treatment option can help you pin down an overall rejuvenation of your face while correcting signs of aging and magnifying your natural beauty.",
            "para": "Here's the reason it's the best:",
            "items": [
                {
                    "title": "Fine Lines & Wrinkles Smoother",
                    "desc": "Botox works wonders to smooth away wrinkles...",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "Prevents New Wrinkles",
                    "desc": "Regular botox treatments prevent new wrinkles from forming...",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Non-Surgical Solution",
                    "desc": "With no downtime or recovery time needed...",
                    "icon": "fa-solid fa-scissors"
                },
                {
                    "title": "Quick & Long-Lasting Results",
                    "desc": "The procedure is quick, taking around 15-30 minutes...",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Improves Facial Symmetry",
                    "desc": "Botox can also be applied to balance muscle activity...",
                    "icon": "fa-solid fa-ruler-horizontal"
                },
                {
                    "title": "Boosts Confidence",
                    "desc": "Full face Botox makes you feel younger and more rejuvenated...",
                    "icon": "fa-solid fa-thumbs-up"
                }
            ]

        },
        "results": {
            "heading": "Botox Full Face Treatment: Everything You Need to Know to Get Your Ideal Look.",
            "subheading": "Expected Results",
            "para": "Routine and frequent Botox treatment of the face usually gets patients excited in regards to their appearance. Results are often subtle but powerful, providing a more youthful, refreshed appearance without drastic changes. This is what you can expect to see in terms of results",
            "items": [
                {
                    "title": "Smoother Surface and Less Wrinkling",
                    "desc": "Boasting a remarkable ability to smooth away wrinkles...",
                    "icon": "fa-solid fa-face-relieved"
                },
                {
                    "title": "Natural-Looking Results",
                    "desc": "Botox relaxes the muscles that cause wrinkles...",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "Gradual Improvement",
                    "desc": "The effects of Botox are not immediate...",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Minimal Side Effects",
                    "desc": "Slight redness or swelling at the injection sites...",
                    "icon": "fa-solid fa-circle-check"
                },
                {
                    "title": "Subtle Lifting Effect",
                    "desc": "A subtle lifting effect is given by treating the forehead...",
                    "icon": "fa-solid fa-arrow-up"
                },
                {
                    "title": "Boost in Confidence",
                    "desc": "Even the slightest changes in the texture of the skin...",
                    "icon": "fa-solid fa-face-grin-stars"
                }
            ]

        },
        "aftercareTips": {
            "heading": "Botox Full Face Aftercare: How to Maximize the Results!",
            "subheading": "Aftercare Tips",
            "para": "Taking proper care of your skin after undergoing Botox full face treatment is imperative to achieving the best results and avoiding unwanted side effects. Although the procedure is non-invasive and involves little to no downtime, there are a few key steps you should take to optimize your experience and keep that youthful glow. Here are important aftercare recommendations:",
            "items": [
                {
                    "title": "Do Not Touch or Rub the Treated Areas",
                    "desc": "Avoid touching, rubbing or massaging the injected areas...",
                    "icon": "fa-solid fa-hand"
                },
                {
                    "title": "Stay Upright for a Few Hours",
                    "desc": "You’re advised to stay upright for at least 4 hours...",
                    "icon": "fa-solid fa-arrow-up-wide-short"
                },
                {
                    "title": "Avoid strenuously exercising for 24 hours",
                    "desc": "Avoid vigorous exercise or anything that makes you sweat heavily...",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "Avoid Heat Exposure",
                    "desc": "Avoid exposing your face to heat within the first 24 to 48 hours...",
                    "icon": "fa-solid fa-temperature-high"
                },
                {
                    "title": "24 Hours Without Any Alcohol",
                    "desc": "Alcohol may thin the blood and make bruising more likely...",
                    "icon": "fa-solid fa-glass-water-droplet"
                },
                {
                    "title": "Skip Facials and Skin Treatments",
                    "desc": "Do not have any more facial treatments for at least two weeks...",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "Gently Cleanse Your Face",
                    "desc": "Use a gentle cleanser and lukewarm water...",
                    "icon": "fa-solid fa-face-smile-beam"
                }
            ]

        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "If you are thinking of Botox Treatment in Dubai you must have some queries in mind about the procedure, the results, aftercare, etc. Below are some of the most common questions to assist you in making an informed decision.",
            "items": [
                {
                    "question": "What exactly is a full face Botox Treatment?",
                    "answer": "A Full Face Botox treatment uses small doses of Botulinum Toxin injections to various parts of the face to temporarily paralyze the muscles that contribute to formation of fine lines and wrinkles. Smiling or frowning several times can make our skin wrinkle, and this holistic approach can treat different zones of the face, including the forehead, frown lines, crow's feet, bunny lines (nose) and lip lines, to give a smoother and younger look. Botox is an excellent choice for the man who wants to minimize the appearance of age or to prevent wrinkle formation, but still have natural movements of the face. The effects usually last four to six months."
                },
                {
                    "question": "How many sessions would you need?",
                    "answer": "One session of Full Face Botox is often sufficient for noticeable results. Improvement from Botox usually takes about 3-5 days to show and reaches its peak effect at around 10–14 days. Because Botox is not permanent, most people require maintenance sessions every 4-6 months to maintain the results and continue enjoying smooth, wrinkle-free skin. How often you have sessions will depend on things that vary between each person like your skin type, age, and muscle movement. Your provider will recommend a personalized treatment plan during your consultation."
                },
                {
                    "question": "How long will the treatment process take?",
                    "answer": "SALON PROCEDURE: This procedure takes anywhere from 15-30minutes depending on which areas you are treating. It’s sometimes called a “lunchtime procedure” because it’s so fast and has so little downtime."
                },
                {
                    "question": "What are the potential side effects?",
                    "answer": "Common side effects are mild and include slight bruising, redness, or swelling at the injection sites. These usually subside within a few hours to a couple of days."
                },
                {
                    "question": "Are Botox Injections Painful?",
                    "answer": "Most patients feel little to no pain upon receiving Botox injections. The needles used are extremely fine, and the procedure is fast. An anesthetic cream may be applied to make treatment more comfortable if needed."
                },
                {
                    "question": "Who is an ideal candidate for Botox Full Face?",
                    "answer": "Botox Full Face is ideal for individuals looking to prevent or reduce the appearance of wrinkles and fine lines. Both men and women of various skin types can benefit from this treatment. During your consultation, we will assess your skin and aesthetic goals to ensure Botox is right for you."
                },
                {
                    "question": "What is the cost of Botox Full Face?",
                    "answer": "Botox Full Face cost varies from individual to individual based on the areas treated and required units. During your consultation, we will create a customized treatment plan with a cost breakdown."
                }
            ]
        },
        "treatmentAreas1": [
            {
                "ar": "",
                "title": "Forehead Lines",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Forehead-Lines.jpg"
            },
            {
                "ar": "خطوط العبوس",
                "title": "Frown Lines",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Frown-Lines.jpg"
            },
            {
                "ar": "تجاعيد أقدام الغراب",
                "title": "Crow's Feet",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Crows-Feet.jpg"
            }
        ],
        "treatmentAreas2": [
            {
                "ar": "خطوط الأرنب",
                "title": "Bunny Lines",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Bunny-Lines.jpg"
            },
            {
                "ar": "خطوط حول الشفاه",
                "title": "Lip Lines",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Lip-Lines.jpg"
            },
            {
                "ar": "تجاعيد الرقبة",
                "title": "Neck Bands",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Neck-Bandss.jpg"
            }
        ]
    },
    "shared": {
        "images": {
            "introductionImage": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/full-face-botoxx.jpeg",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Astatic-Clinic-in-Dubai-7-scaled.jpg",
            "beforeAfter": [
                { "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/full-face-botox-in-dubai-1.jpg", "alt": "full face botox" },
                { "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/full-face-botox-in-dubai-2.jpg", "alt": "full face botox" },
                { "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/full-face-botox-in-dubai-3.jpg", "alt": "full face botox" },
            ]
        },
        "product": {
            "id": 1,
            "title": "Full Face Botox",
            "price": 499,
            "description": "Full Face Botox smooths fine lines and wrinkles by relaxing facial muscles, giving you a youthful, refreshed, and natural look."
        }
    },
    "ar": {
        "url": "full-face-botox-dubai",
        "meta": {
            "title": "بوتوكس الوجه الكامل دبي | Elite Body Home Polyclinic",
            "description": "ابدو أصغر سناً وأكثر حيوية مع علاج البوتوكس للوجه بالكامل في دبي. نحن نقدم علاجات مخصصة لنعومة الخطوط الدقيقة، تخفيف التجاعيد، ومنع علامات الشيخوخة.",
            "robots": "index, follow",
            "canonical": "",
            "og": {}
        },
        "breadcrumbs": [
            "الرئيسية",
            "الخدمات",
            "بوتوكس الوجه الكامل دبي"
        ],
        "hero": {
            "title": "بوتوكس دبي",
            "subtitle": "علاج البوتوكس للوجه بالكامل",
            "description": "ابدو أصغر سناً وأكثر حيوية مع علاج البوتوكس للوجه بالكامل في Elite Body Home Polyclinic دبي. من تنعيم الخطوط الدقيقة إلى تخفيف التجاعيد العميقة إلى منع علامات الشيخوخة، يقدم أخصائيوونا علاجات بوتوكس مخصصة بناءً على أهدافك الجمالية."
        },
        "howItWorks": {
            "title": "حقن البوتوكس: كيف تعمل",
            "description": "حقن البوتوكس هي علاج تجميلي مؤقت يشل العضلات المسببة للخطوط الدقيقة والتجاعيد. تستخدم الحقن جرعات صغيرة ومتحكم بها من توكسين البوتولينوم يتم حقنها في عضلات وجه محددة لإرخائها مؤقتًا وتنعيمها، مما يقلل من ظهور التجاعيد الديناميكية مثل خطوط الجبهة، خطوط العبوس، وخطوط الزحل. سيحرص المحترفون المدربون جيدًا على إعطائها بشكل صحيح وآمن للحصول على نتائج طبيعية."
        },
        "procedureSteps": {
            "heading": "خطوات إجراء تجديد البوتوكس خطوة بخطوة",
            "para": "يتكون إجراء البوتوكس للوجه الكامل من عدة خطوات مهمة لضمان السلامة والكفاءة والنتائج الطبيعية. يتم إجراء العلاج من قبل أخصائي مرخص وذو خبرة، ويستغرق عادةً من 20 إلى 45 دقيقة. فيما يلي وصف عام للعملية.",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "يقوم الأخصائي بتحليل ملامح وجهك وأهدافك لوضع خطة علاج مخصصة.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "التحضير",
                    "desc": "يتم تعقيم البشرة وقد يتم وضع كريم مخدر. يتم تحديد نقاط الحقن الرئيسية.",
                    "icon": "fa-solid fa-spray-can-sparkles"
                },
                {
                    "title": "الحقن",
                    "desc": "يتم استخدام إبرة دقيقة لحقن البوتوكس في المناطق المطلوبة. تستغرق حوالي 10-15 دقيقة مع انزعاج محتمل.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "مدة الجلسة",
                    "desc": "تستغرق الجلسة عادةً من 15 إلى 30 دقيقة، حسب المناطق المعالجة والاحتياجات الفردية.",
                    "icon": "fa-solid fa-stopwatch"
                }
            ]
        },
        "eligibility": {
            "heading": "لمن يصلح البوتوكس للوجه الكامل؟",
            "subheading": "اكتشف إذا كان مناسبًا لك",
            "para": "يهدف علاج البوتوكس للوجه الكامل للأشخاص الذين يبحثون عن طريقة غير جراحية لتحسين مظهرهم، تقليل التجاعيد وتحقيق مظهر أكثر شبابًا. إليك كيفية معرفة ما إذا كان هذا العلاج مناسبًا لك.",
            "items": [
                {
                    "title": "علامات الشيخوخة المبكرة",
                    "desc": "إذا كنت ترى خطوط دقيقة، تجاعيد العين أو تجاعيد الجبهة، فإن البوتوكس سينعمها لمظهر أكثر نضارة.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "العلاجات غير الجراحية",
                    "desc": "مثالي للمرضى الذين يرغبون في تغيير أكثر وضوحًا ولكن طبيعي دون مخاطر الجراحة أو فترة النقاهة.",
                    "icon": "fa-solid fa-hand-holding-heart"
                },
                {
                    "title": "العلاج الوقائي",
                    "desc": "يمكن أن يختلف البوتوكس حسب الفئات العمرية... يمكن للشباب استخدام البوتوكس كإجراء وقائي...",
                    "icon": "fa-solid fa-shield-heart"
                },
                {
                    "title": "رعاية مخصصة",
                    "desc": "يقدم البوتوكس للوجه الكامل علاجات مستهدفة للجبهة، العينين، خط الفك، والمزيد...",
                    "icon": "fa-solid fa-user-gear"
                }
            ]
        },
        "preparationTips": {
            "heading": "كيف تستعد لإجراءات البوتوكس للوجه الكامل؟",
            "subheading": "نصائح التحضير",
            "para": "للحصول على أفضل النتائج من علاج البوتوكس للوجه الكامل، من الضروري التحضير بشكل صحيح. إليك بعض النصائح الأساسية لضمان تجربة إيجابية والفوائد الدائمة:",
            "items": [
                {
                    "title": "استشر متخصصًا",
                    "desc": "احجز استشارة لمناقشة أهدافك والتأكد من أن البوتوكس مناسب لك.",
                    "icon": "fa-solid fa-comments-medical"
                },
                {
                    "title": "حافظ على رطوبتك",
                    "desc": "تجنب الأسبرين، الإيبوبروفين والمكملات مثل زيت السمك قبل أسبوع من موعدك...",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "تجنب الكحول",
                    "desc": "لا تشرب الكحول قبل 24 ساعة من موعدك لتقليل التورم.",
                    "icon": "fa-solid fa-wine-glass-crack"
                },
                {
                    "title": "احضر ببشرة نظيفة",
                    "desc": "في يوم العلاج، احضر ببشرة نظيفة دون مكياج أو مرطبات.",
                    "icon": "fa-solid fa-soap"
                }
            ]
        },
        "benefits": {
            "heading": "علاج البوتوكس للوجه الكامل",
            "subheading": "يمكن لخيار العلاج الكامل للوجه أن يساعدك في تحقيق تجديد شامل لوجهك مع تصحيح علامات الشيخوخة وتعزيز جمالك الطبيعي.",
            "para": "هنا السبب في أنه الأفضل:",
            "items": [
                {
                    "title": "تنعيم الخطوط الدقيقة والتجاعيد",
                    "desc": "يعمل البوتوكس بشكل رائع على تنعيم التجاعيد...",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "يمنع التجاعيد الجديدة",
                    "desc": "علاجات البوتوكس المنتظمة تمنع تكون تجاعيد جديدة...",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "حل غير جراحي",
                    "desc": "بدون الحاجة إلى فترة نقاهة أو تعافي...",
                    "icon": "fa-solid fa-scissors"
                },
                {
                    "title": "نتائج سريعة ودائمة",
                    "desc": "الإجراء سريع، يستغرق حوالي 15-30 دقيقة...",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "يحسن تناسق الوجه",
                    "desc": "يمكن أيضًا استخدام البوتوكس لتحقيق توازن في نشاط العضلات...",
                    "icon": "fa-solid fa-ruler-horizontal"
                },
                {
                    "title": "يعزز الثقة",
                    "desc": "البوتوكس للوجه الكامل يجعلك تشعر بأنك أصغر سناً وأكثر حيوية...",
                    "icon": "fa-solid fa-thumbs-up"
                }
            ]
        },
        "results": {
            "heading": "علاج البوتوكس للوجه الكامل: كل ما تحتاج معرفته للحصول على مظهرك المثالي.",
            "subheading": "النتائج المتوقعة",
            "para": "عادةً ما يكون المرضى متحمسين لمظهرهم بعد علاج البوتوكس المنتظم للوجه. غالبًا ما تكون النتائج خفيفة ولكنها قوية، مما يوفر مظهرًا أكثر شبابًا وانتعاشًا دون تغييرات جذرية. إليك ما يمكنك توقعه من حيث النتائج",
            "items": [
                {
                    "title": "سطح أكثر نعومة وتجاعيد أقل",
                    "desc": "يتمتع بقدرة ملحوظة على تنعيم التجاعيد...",
                    "icon": "fa-solid fa-face-relieved"
                },
                {
                    "title": "نتائج طبيعية المظهر",
                    "desc": "يرخي البوتوكس العضلات المسببة للتجاعيد...",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "تحسن تدريجي",
                    "desc": "تأثيرات البوتوكس ليست فورية...",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "آثار جانبية طفيفة",
                    "desc": "احمرار أو تورم طفيف في مواقع الحقن...",
                    "icon": "fa-solid fa-circle-check"
                },
                {
                    "title": "تأثير رفع خفيف",
                    "desc": "يتم تحقيق تأثير رفع خفيف عن طريق علاج الجبهة...",
                    "icon": "fa-solid fa-arrow-up"
                },
                {
                    "title": "زيادة الثقة",
                    "desc": "حتى التغييرات الطفيفة في نسيج البشرة...",
                    "icon": "fa-solid fa-face-grin-stars"
                }
            ]
        },
        "aftercareTips": {
            "heading": "العناية بعد البوتوكس للوجه الكامل: كيفية تحقيق أقصى قدر من النتائج!",
            "subheading": "نصائح ما بعد العلاج",
            "para": "العناية الصحيحة ببشرتك بعد علاج البوتوكس للوجه الكامل ضرورية لتحقيق أفضل النتائج وتجنب الآثار الجانبية غير المرغوب فيها. على الرغم من أن الإجراء غير جراحي ولا يتطلب فترة نقاهة تقريبًا، إلا أن هناك بعض الخطوات الرئيسية التي يجب اتخاذها لتحسين تجربتك والحفاظ على ذلك التوهج الشبابي. فيما يلي توصيات مهمة للعناية اللاحقة:",
            "items": [
                {
                    "title": "لا تلمس أو تفرك المناطق المعالجة",
                    "desc": "تجنب لمس أو فرك أو تدليك المناطق المحقونة...",
                    "icon": "fa-solid fa-hand"
                },
                {
                    "title": "ابق في وضع مستقيم لبضع ساعات",
                    "desc": "ينصح بالبقاء في وضع مستقيم لمدة 4 ساعات على الأقل...",
                    "icon": "fa-solid fa-arrow-up-wide-short"
                },
                {
                    "title": "تجنب التمارين الشاقة لمدة 24 ساعة",
                    "desc": "تجنب التمارين القوية أو أي شيء يجعلك تتعرق بشدة...",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "تجنب التعرض للحرارة",
                    "desc": "تجنب تعريض وجهك للحرارة خلال أول 24 إلى 48 ساعة...",
                    "icon": "fa-solid fa-temperature-high"
                },
                {
                    "title": "24 ساعة بدون كحول",
                    "desc": "قد يخفف الكحول الدم ويزيد من احتمالية الكدمات...",
                    "icon": "fa-solid fa-glass-water-droplet"
                },
                {
                    "title": "تجنب العناية بالبشرة والعلاجات الجلدية",
                    "desc": "لا تخضع لأي علاجات للوجه لمدة أسبوعين على الأقل...",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "نظف وجهك بلطف",
                    "desc": "استخدم منظفًا لطيفًا وماءً فاترًا...",
                    "icon": "fa-solid fa-face-smile-beam"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "إذا كنت تفكر في علاج البوتوكس في دبي، فقد يكون لديك بعض الاستفسارات حول الإجراء، النتائج، العناية اللاحقة، إلخ. فيما يلي بعض الأسئلة الأكثر شيوعًا لمساعدتك في اتخاذ قرار مستنير.",
            "items": [
                {
                    "question": "ما هو بالضبط علاج البوتوكس للوجه الكامل؟",
                    "answer": "يستخدم علاج البوتوكس للوجه الكامل جرعات صغيرة من حقن توكسين البوتولينوم في أجزاء مختلفة من الوجه لشل العضلات التي تساهم في تكوين الخطوط الدقيقة والتجاعيد مؤقتًا. يمكن أن يجعل الابتسام أو العبوس المتكرر بشرتنا تتجعد، ويمكن لهذا النهج الشامل علاج مناطق مختلفة من الوجه، بما في ذلك الجبهة، خطوط العبوس، تجاعيد العينين، خطوط الأرنب (الأنف) وخطوط الشفاه، لإعطاء مظهر أكثر نعومة وشبابًا. يعد البوتوكس خيارًا ممتازًا للرجل الذي يرغب في تقليل مظهر العمر أو منع تكوين التجاعيد، مع الحفاظ على حركات الوجه الطبيعية. تستمر التأثيرات عادة من أربعة إلى ستة أشهر."
                },
                {
                    "question": "كم عدد الجلسات التي ستحتاجها؟",
                    "answer": "غالبًا ما تكون جلسة واحدة من البوتوكس للوجه الكامل كافية للحصول على نتائج ملحوظة. عادةً ما يستغرق التحسن من البوتوكس حوالي 3-5 أيام ليظهر ويصل إلى ذروة تأثيره في حوالي 10-14 يومًا. لأن البوتوكس ليس دائمًا، يحتاج معظم الأشخاص إلى جلسات صيانة كل 4-6 أشهر للحفاظ على النتائج والاستمرار في الاستمتاع ببشرة ناعمة خالية من التجاعيد. يعتمد عدد الجلسات التي تخضع لها على أشياء تختلف بين كل شخص مثل نوع بشرتك، عمرك، وحركة العضلات. سيوصي مقدم الخدمة بخطة علاج مخصصة خلال استشارتك."
                },
                {
                    "question": "كم من الوقت ستستغرق عملية العلاج؟",
                    "answer": "إجراء الصالون: يستغرق هذا الإجراء من 15 إلى 30 دقيقة حسب المناطق التي يتم علاجها. يُطلق عليه أحيانًا اسم \"إجراء وقت الغداء\" لأنه سريع جدًا ولديه وقت تعافٍ قليل جدًا."
                },
                {
                    "question": "ما هي الآثار الجانبية المحتملة؟",
                    "answer": "الآثار الجانبية الشائعة خفيفة وتشمل كدمات طفيفة، احمرار، أو تورم في مواقع الحقن. عادة ما تختفي هذه الأعراض في غضون بضع ساعات إلى بضعة أيام."
                },
                {
                    "question": "هل حقن البوتوكس مؤلمة؟",
                    "answer": "يشعر معظم المرضى بألم قليل أو معدوم عند تلقي حقن البوتوكس. الإبر المستخدمة دقيقة للغاية، والإجراء سريع. يمكن تطبيق كريم مخدر لجعل العلاج أكثر راحة إذا لزم الأمر."
                },
                {
                    "question": "من هو المرشح المثالي للبوتوكس للوجه الكامل؟",
                    "answer": "البوتوكس للوجه الكامل مثالي للأفراد الذين يتطلعون إلى منع أو تقليل ظهور التجاعيد والخطوط الدقيقة. يمكن لكل من الرجال والنساء من مختلف أنواع البشرة الاستفادة من هذا العلاج. خلال استشارتك، سنقيم بشرتك وأهدافك الجمالية للتأكد من أن البوتوكس مناسب لك."
                },
                {
                    "question": "ما هي تكلفة البوتوكس للوجه الكامل؟",
                    "answer": "تختلف تكلفة البوتوكس للوجه الكامل من فرد لآخر بناءً على المناطق المعالجة والوحدات المطلوبة. خلال استشارتك، سنقوم بإنشاء خطة علاج مخصصة مع تفصيل التكلفة."
                }
            ]
        },
        "treatmentAreas1": [
            {
                "ar": "خطوط الجبهة",
                "title": "Forehead Lines",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Forehead-Lines.jpg"
            },
            {
                "ar": "خطوط العبوس",
                "title": "Frown Lines",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Frown-Lines.jpg"
            },
            {
                "ar": "تجاعيد أقدام الغراب",
                "title": "Crow's Feet",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Crows-Feet.jpg"
            }
        ],
        "treatmentAreas2": [
            {
                "ar": "خطوط الأرنب",
                "title": "Bunny Lines",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Bunny-Lines.jpg"
            },
            {
                "ar": "خطوط حول الشفاه",
                "title": "Lip Lines",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Lip-Lines.jpg"
            },
            {
                "ar": "تجاعيد الرقبة",
                "title": "Neck Bands",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Neck-Bandss.jpg"
            }
        ]
    }

};
